
//1.Import
import "@lottiefiles/lottie-player";
import Layout from '../Layout';
import SectionAbout from '../sections/SectionAbout';
import SectionPoint from '../sections/SectionPoint';
import SectionFlow from '../sections/SectionFlow';
import SectionSurprise from '../sections/SectionSurprise';
import SectionReviews from '../sections/SectionReviews';

//2.Initialization
const layout=new Layout({ enableSmoothScroll: true });
const sectionAbout= new SectionAbout();
const sectionPoint= new SectionPoint();
const sectionFlow= new SectionFlow();
const sectionSurprise= new SectionSurprise();
const sectionReviews= new SectionReviews();

//3.Events
window.addEventListener('DOMContentLoaded', function() {
    sectionAbout.init();
    sectionPoint.init();
    sectionFlow.init();
    sectionSurprise.init();
    sectionReviews.init();
    changeVideoSource();
});

// Add event listener to monitor screen size changes
window.addEventListener('resize', changeVideoSource);

// Function to change video source based on window size
function changeVideoSource() {
    let video = document.getElementById('banner-video');
    let source = document.getElementById('video-source');
    let bannerDesktopVideo = document.querySelector('#bannerDesktopVideo').value;
    let bannerMobileVideo = document.querySelector('#bannerMobileVideo').value;
    // Use getAttribute to retrieve the exact src value as set in the HTML
    let currentSrc = source.getAttribute('src');

    // Check if the window width is less than 768px
    if (window.innerWidth <= 768) {
        // If less than 768px, change to the mobile video
        if (currentSrc !== bannerMobileVideo) {
            source.setAttribute('src', bannerMobileVideo);
            video.load(); // Reload the video with the new source
        }
    } else {
        // If greater than or equal to 768px, use the desktop video
        if (currentSrc !== bannerDesktopVideo) {
            source.setAttribute('src', bannerDesktopVideo);
            video.load(); // Reload the video with the new source
        }
    }
}


